"use client";
import { Image } from "@/components/Image";
import { clickEvent } from "@/lib/atInternetTags";
import Link from "next/link";
import { MailIcon, PhoneIcon } from "ui/iconsN";

export const Contact = () => (
  <div className="bg-tx-2 text-bg-2">
    <div className="container flex flex-col gap-8 md md:flex-row md:gap-4 py-12 md:py-8 md:justify-evenly">
      <div className="flex flex-col gap-6">
        <p className="text-2xl font-semibold whitespace-nowrap">Contacts</p>
        <div className="flex items-center gap-2">
          <PhoneIcon />
          <a href="tel:+33145619090" className="hover:text-pr-1 hover:underline">
            01 45 61 90 90
          </a>
        </div>
        <div className="flex items-center gap-2">
          <MailIcon />
          <a className="hover:text-pr-1 hover:underline" href="mailto:lesamis@intermedes.com">
            lesamis@intermedes.com
          </a>
        </div>
      </div>
      <div className="flex flex-col gap-6">
        <p className="text-2xl font-semibold whitespace-nowrap">Suivez-nous !</p>
        <p className="max-w-80">
          Pour suivre l’actualité des amis d’Intermèdes, retrouvez-nous sur les réseaux sociaux :
        </p>
        <div className="flex items-center gap-6">
          <a
            href="https://www.facebook.com/intermedesvoyages/"
            target="_blank"
            rel="noreferrer"
            onClick={() =>
              clickEvent({
                event: "click.exit",
                click: "facebook",
                click_chapter1: "reseaux_sociaux",
              })
            }
            className="block w-8 shrink-0"
          >
            <Image
              sizes="32px"
              alt="Facebook"
              image={{
                type: "asset",
                name: "f_facebook_1.png",
                realname: "f_facebook_1.png",
              }}
              height={{
                type: "ratio",
                value: 100,
              }}
            />
          </a>
          <a
            href="https://www.instagram.com/intermedes/"
            target="_blank"
            rel="noreferrer"
            onClick={() =>
              clickEvent({
                event: "click.exit",
                click: "instagram",
                click_chapter1: "reseaux_sociaux",
              })
            }
            className="block w-[30px] shrink-0"
          >
            <Image
              sizes="32px"
              alt="Instagram"
              image={{
                type: "asset",
                name: "f_instagram_1.png",
                realname: "f_instagram_1.png",
              }}
              height={{
                type: "ratio",
                value: 100,
              }}
            />
          </a>
        </div>
      </div>
      <div className="flex flex-col gap-6">
        <p className="text-2xl font-semibold whitespace-nowrap">Services</p>
        <div className="flex flex-col">
          <Link href="/amis/agenda/" className="hover:text-pr-1 hover:underline">
            Agenda
          </Link>
          <Link href="/amis/themes/" className="hover:text-pr-1 hover:underline">
            Nos thèmes
          </Link>
          <Link href="/amis/conferenciers/" className="hover:text-pr-1 hover:underline">
            Nos conférenciers
          </Link>
          <Link href="/amis/replays/" className="hover:text-pr-1 hover:underline">
            Replays
          </Link>
          <Link href="/amis/tarifs/" className="hover:text-pr-1 hover:underline">
            Tarifs
          </Link>
          <Link href="/amis/qui-sommes-nous/" className="hover:text-pr-1 hover:underline">
            Qui sommes-nous ?
          </Link>
          <Link
            href="/amis/conditions-generales-et-particulieres-de-vente/"
            className="hover:text-pr-1 hover:underline"
          >
            Mentions légales
          </Link>
        </div>
      </div>
    </div>
  </div>
);
